export const UserCreatedSegmentIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1327_13179)">
        <path
          d="M1.5 14.25V3.75C1.5 3.3375 1.64687 2.98438 1.94062 2.69063C2.23437 2.39687 2.5875 2.25 3 2.25H7.5C7.9125 2.25 8.26562 2.39687 8.55937 2.69063C8.85312 2.98438 9 3.3375 9 3.75V5.25H15C15.4125 5.25 15.7656 5.39688 16.0594 5.69063C16.3531 5.98438 16.5 6.3375 16.5 6.75V14.25C16.5 14.6625 16.3531 15.0156 16.0594 15.3094C15.7656 15.6031 15.4125 15.75 15 15.75H3C2.5875 15.75 2.23437 15.6031 1.94062 15.3094C1.64687 15.0156 1.5 14.6625 1.5 14.25ZM3 14.25H4.5V12.75H3V14.25ZM3 11.25H4.5V9.75H3V11.25ZM3 8.25H4.5V6.75H3V8.25ZM3 5.25H4.5V3.75H3V5.25ZM6 14.25H7.5V12.75H6V14.25ZM6 11.25H7.5V9.75H6V11.25ZM6 8.25H7.5V6.75H6V8.25ZM6 5.25H7.5V3.75H6V5.25ZM9 14.25H15V6.75H9V8.25H10.5V9.75H9V11.25H10.5V12.75H9V14.25ZM12 9.75V8.25H13.5V9.75H12ZM12 12.75V11.25H13.5V12.75H12Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_1327_13179">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
